<div (click)="toggle()">
  <span
    class="inline-flex items-center gap-x-1 rounded-md px-4 py-1 text-base font-medium ring-2 ring-inset"
    [class.bg-gray-50]="selected"
    [class.ring-black]="selected"
    [class.text-black]="selected"
    [class.text-gray-600]="!selected"
    [class.ring-gray-300]="!selected"
  >
    <div class="flex flex-col">
      <span
        [class.font-bold]="labelDescription"
        [class.mb-1]="labelDescription"
      >
        {{ label }}
      </span>
      <span>
        {{ labelDescription }}
      </span>
    </div>

    <button
      *ngIf="selected"
      type="button"
      class="group relative -mr-1 h-6 w-6 rounded-sm hover:bg-gray-500/20"
    >
      <span class="sr-only">Remove</span>
      <svg
        viewBox="0 0 14 14"
        class="h-6 w-6 stroke-gray-600/50 group-hover:stroke-gray-600/75"
      >
        <path d="M4 4l6 6m0-6l-6 6" />
      </svg>
      <span class="absolute -inset-1"></span>
    </button>
  </span>
</div>
